import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import {
  Box,
  Button,
  Divider,
  Menu,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../api/hooks/useColors";

// Marks for the sliders
const marks = [
  { value: 0, label: <Typography variant="caption">Very Low</Typography> },
  { value: 25, label: <Typography variant="caption">Low</Typography> },
  { value: 75, label: <Typography variant="caption">High</Typography> },
  { value: 100, label: <Typography variant="caption">Very High</Typography> },
];

const RiskParameters = ({ appliedFilters, setAppliedFilters }) => {
  // Initial state for range sliders with two values [min, max]
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const [likelihoodRange, setLikelihoodRange] = useState(
    appliedFilters.riskParameters?.likelihood || [25, 75]
  );
  const [probabilityRange, setProbabilityRange] = useState(
    appliedFilters.riskParameters?.probability || [25, 75]
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLikelihoodChange = (event, newValue) => {
    setLikelihoodRange(newValue);
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      riskParameters: {
        ...prevFilters.riskParameters,
        likelihood: newValue,
      },
    }));
  };

  const handleProbabilityChange = (event, newValue) => {
    setProbabilityRange(newValue);
    setAppliedFilters((prevFilters) => ({
      ...prevFilters,
      riskParameters: {
        ...prevFilters.riskParameters,
        probability: newValue,
      },
    }));
  };

  const valueFormatter = (value) => {
    let newValue = "";
    if (value >= 0 && value <= 25) {
      newValue = "Very Low";
    } else if (value > 25 && value <= 50) {
      newValue = "Low";
    } else if (value > 50 && value <= 75) {
      newValue = "High";
    } else if (value > 75 && value <= 100) {
      newValue = "Very High";
    } else {
      newValue = null;
    }

    return newValue;
  };
  return (
    <Box>
      <Button
        sx={{
          background: colors.grey_50,
          color: colors.text_primary,
          height: "32px",
          border: "1px solid " + colors.grey_32percent,
          textTransform: "unset",
          borderRadius: "8px",
          fontSize: "12px",
          display: "flex",
        }}
        onClick={handleClick}
        endIcon={
          <KeyboardArrowDownRoundedIcon
            style={{ width: "20px", height: "20px" }}
          />
        }
      >
        <Typography variant="caption">Risk Parameters</Typography>
      </Button>
      {/* Menu that contains the range sliders */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: "350px",
            borderRadius: "8px",
            height: "220px",
            padding: "5px 20px",
          },
        }}
      >
        {/* Likelihood Range Slider */}
        <Box>
          <Box pb={4}>
            <Typography variant="overline">Likelihood</Typography>
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "space-around",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Box width={"90%"} display={"flex"} justifyContent={"center"}>
                <Slider
                  size="small"
                  value={likelihoodRange}
                  onChange={handleLikelihoodChange}
                  marks={marks}
                  min={0}
                  max={100}
                  valueLabelDisplay="auto"
                  disableSwap
                  step={null}
                  valueLabelFormat={valueFormatter}
                  sx={{
                    color: colors.primary_main,
                    height: 4, // Adjust the height to make the slider smaller
                    margin: "0 auto", // Center the slider horizontally
                    "& .MuiSlider-thumb": {
                      width: 12, // Adjust the thumb size
                      height: 12, // Adjust the thumb size
                    },
                    "& .MuiSlider-track": {
                      height: 4, // Adjust the track height
                    },
                    "& .MuiSlider-rail": {
                      height: 4, // Adjust the rail height
                    },
                  }}
                />
              </Box>
            </Stack>
          </Box>
          <Box>
            <Divider />
          </Box>
          <Box pt={2}>
            <Typography variant="overline">Probability</Typography>
            <Stack
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                justifyContent: "space-around",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <Box width={"90%"} display={"flex"} justifyContent={"center"}>
                <Slider
                  value={probabilityRange}
                  onChange={handleProbabilityChange}
                  marks={marks}
                  min={0}
                  max={100}
                  step={null}
                  valueLabelDisplay="auto"
                  disableSwap
                  valueLabelFormat={valueFormatter}
                  sx={{
                    color: colors.primary_main,
                    height: 4, // Adjust the height to make the slider smaller
                    margin: "0 auto", // Center the slider horizontally
                    "& .MuiSlider-thumb": {
                      width: 12, // Adjust the thumb size
                      height: 12, // Adjust the thumb size
                    },
                    "& .MuiSlider-track": {
                      height: 4, // Adjust the track height
                    },
                    "& .MuiSlider-rail": {
                      height: 4, // Adjust the rail height
                    },
                  }}
                />
              </Box>
            </Stack>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
};

export default RiskParameters;
